<div class="main-container input" (click)="toggleTimepicker($event)">
  <p class="mb-0 time-value">{{ formattedTime || 'Pick Time' }}</p>
</div>